import React, { useState } from "react";
import { Link, useLocation } from "react-router-dom";

const FieldGuideNavigation = ({ onNavClick }) => {
  const [isExpanded, setIsExpanded] = useState(false);
  const location = useLocation();

  const isActive = (path) => {
    return location.pathname === path || location.pathname.startsWith(path);
  };

  const isFieldGuideActive = location.pathname === "/field-guide" || 
    location.pathname.startsWith("/field-guide/");

  const fieldGuidePages = [
    { path: "/field-guide/seasonal-planting", name: "Seasonal Planting" },
    { path: "/field-guide/crop-rotation", name: "Crop Rotation" },
    { path: "/field-guide/soil-management", name: "Soil Management" },
    { path: "/field-guide/plot-management", name: "Plot Management" }
  ];

  const handleExpandClick = (e) => {
    e.preventDefault();
    setIsExpanded(!isExpanded);
  };

  const handleLinkClick = () => {
    if (onNavClick) {
      onNavClick();
    }
  };

  return (
    <>
      <Link 
        to="/field-guide" 
        className={`nav-link ${isFieldGuideActive ? 'active' : ''}`}
        onClick={handleExpandClick}
        style={{ cursor: 'pointer' }}
      >
        Field Guide {isExpanded ? '☟' : '☞'}
      </Link>
      
      {isExpanded && (
        <div className="field-guide-subpages">
          {fieldGuidePages.map((page) => (
            <Link 
              key={page.path}
              to={page.path} 
              className={`nav-link field-guide-subpage ${isActive(page.path) ? 'active' : ''}`}
              onClick={handleLinkClick}
            >
              {page.name}
            </Link>
          ))}
        </div>
      )}
    </>
  );
};

export default FieldGuideNavigation;
